module.exports = __webpack_public_path__ + "static/media/Maf_07Mayo.fcdc9fb6.jpg";